
// Mock telemetry data for energy devices
export const mockTelemetryData = [
  {
    timestamp: "2024-12-15T00:00:00Z",
    smartMeters: {
      online: 48,
      warning: 7,
      critical: 2,
      offline: 3,
      totalReadings: 14520,
      averagePower: 1456.8,
      maintenanceStats: {
        scheduledMaintenance: 5,
        recentlyServiced: 12,
        needingMaintenance: 8,
        overdueMaintenance: 3
      }
    },
    gateways: {
      online: 3,
      warning: 1,
      critical: 0,
      offline: 0,
      averageLatency: 42,
      dataTransferred: 285.4,
      maintenanceStats: {
        scheduledMaintenance: 1,
        recentlyServiced: 2,
        needingMaintenance: 1,
        overdueMaintenance: 0
      }
    }
  },
  {
    timestamp: "2024-12-14T00:00:00Z",
    smartMeters: {
      online: 50,
      warning: 5,
      critical: 3,
      offline: 2,
      totalReadings: 14832,
      averagePower: 1478.2,
      maintenanceStats: {
        scheduledMaintenance: 4,
        recentlyServiced: 10,
        needingMaintenance: 9,
        overdueMaintenance: 3
      }
    },
    gateways: {
      online: 4,
      warning: 1,
      critical: 0,
      offline: 0,
      averageLatency: 38,
      dataTransferred: 302.7,
      maintenanceStats: {
        scheduledMaintenance: 2,
        recentlyServiced: 1,
        needingMaintenance: 2,
        overdueMaintenance: 0
      }
    }
  },
  {
    timestamp: "2024-12-13T00:00:00Z",
    smartMeters: {
      online: 52,
      warning: 3,
      critical: 2,
      offline: 3,
      totalReadings: 15120,
      averagePower: 1502.5,
      maintenanceStats: {
        scheduledMaintenance: 6,
        recentlyServiced: 8,
        needingMaintenance: 11,
        overdueMaintenance: 2
      }
    },
    gateways: {
      online: 5,
      warning: 0,
      critical: 0,
      offline: 0,
      averageLatency: 35,
      dataTransferred: 315.8,
      maintenanceStats: {
        scheduledMaintenance: 2,
        recentlyServiced: 1,
        needingMaintenance: 2,
        overdueMaintenance: 0
      }
    }
  },
  {
    timestamp: "2024-12-12T00:00:00Z",
    smartMeters: {
      online: 51,
      warning: 4,
      critical: 1,
      offline: 4,
      totalReadings: 15000,
      averagePower: 1485.3,
      maintenanceStats: {
        scheduledMaintenance: 5,
        recentlyServiced: 9,
        needingMaintenance: 10,
        overdueMaintenance: 2
      }
    },
    gateways: {
      online: 4,
      warning: 1,
      critical: 0,
      offline: 0,
      averageLatency: 40,
      dataTransferred: 298.2,
      maintenanceStats: {
        scheduledMaintenance: 1,
        recentlyServiced: 2,
        needingMaintenance: 1,
        overdueMaintenance: 1
      }
    }
  },
  {
    timestamp: "2024-12-11T00:00:00Z",
    smartMeters: {
      online: 49,
      warning: 6,
      critical: 3,
      offline: 2,
      totalReadings: 14640,
      averagePower: 1462.9,
      maintenanceStats: {
        scheduledMaintenance: 4,
        recentlyServiced: 7,
        needingMaintenance: 12,
        overdueMaintenance: 4
      }
    },
    gateways: {
      online: 3,
      warning: 1,
      critical: 1,
      offline: 0,
      averageLatency: 45,
      dataTransferred: 275.6,
      maintenanceStats: {
        scheduledMaintenance: 0,
        recentlyServiced: 2,
        needingMaintenance: 1,
        overdueMaintenance: 2
      }
    }
  }
];
